<div mat-dialog-title>
    <app-avatar-block [svgIcon]="'v2:fi-br-check'" [wrappedText]="true">
        <h3 avatarTitle>{{ 'Test Mode Deactivated' }}</h3>
        <p avatarDescription>{{ 'You\'ve exited test mode. Now, it\'s time to create your first real community and start managing it seamlessly.' }}</p>
    </app-avatar-block>
</div>

<mat-dialog-actions>
    <button mat-flat-button disableRipple color="primary" mat-dialog-close>{{ 'Create New Community' }}</button>
</mat-dialog-actions>
